// extracted by mini-css-extract-plugin
export default {"list":"PagedList_list_H5lSy","datetime":"PagedList_datetime_WBUmr"};